import UtilityPageNav from "content-ui/utilityPages/components/utilityPageNav";
import Headline from "./components/headline";
import ProductShelf from "./components/productShelf";
import TeamSection from "./components/teamSection";
import BrandKit from "./components/brandKit";
import type { AboutPageData } from "./types";

type AboutViewProps = {
  data: AboutPageData["aboutPage"];
};

export default function AboutView({ data }: AboutViewProps) {
  const innerContainerClasses =
    "relative flex flex-col pb-[100px] md:mx-auto lg:flex-row md:max-w-[1040px] lg:max-w-[1220px] px-5 lg:px-0";

  return (
    <main
      data-page-type="about"
      className="bg-[#F6F6F6] text-[16px] leading-[130%] text-black-rock"
    >
      <div className={innerContainerClasses}>
        <UtilityPageNav />

        <div className="flex flex-col lg:flex-row">
          <div className="mt-[1.25rem]">
            <Headline headline={data.headline} subtitle={data.subtitle} />
            <ProductShelf products={data.productShelf} />
            <TeamSection data={data} />
            <BrandKit data={data} />
          </div>
        </div>
      </div>
    </main>
  );
}
